import { Theme, WithStyles, Grid, Paper, Typography, withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import * as React from "react";
import { connect } from "react-redux";
import {RouteComponentProps } from "react-router-dom";
import googleMaps from "src/api/googleMaps";

import { ConfigData } from "src/config";
import { IStore } from "src/store";
import { mockTheme, WithActions, bindActions } from "src/utils/utils";
import DriverDetailComponent from "./DriverDetailComponent";
import { DriverActions } from "src/store/driver";

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
});

const classesType = styles(mockTheme);

interface DriverDetailPageProps extends RouteComponentProps<any>,
  WithStyles<keyof typeof classesType>,
  WithActions<DriverActions> {
  config: ConfigData;
  driverDetail: any;
  data: any;
}

class DriverDetailPage extends React.Component<DriverDetailPageProps>{
  // trace?: NodeJS.Timer;

  constructor(props: DriverDetailPageProps) {
    super(props);
  }

   back() {
      this.props.history.goBack();
   }

  renderOpportunity(opport: any) {
    return (
      <Grid container spacing={16} direction="column">
        <Grid item sm={12} md={6} /*lg={6}*/>
          <Paper elevation={5} style={{ padding: 10 }}>
          <Button color="primary" onClick={() => this.back()}><svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M5 12l6 6" /><path d="M5 12l6 -6" /></svg>{"Volver"}</Button>
          </Paper>
        </Grid>
        <Grid direction='row'>
          <Paper elevation={5} style={{ padding: 10 }}>
            <DriverDetailComponent
            // config={this.props.location.state.config}
            config={this.props.config}
              driverDetail={opport}
              rutaMapa={() =>
                (opport.lat && opport.lng && this.props.config) ? googleMaps.buildStaticImage(this.props.config.maps.key, `center=${opport.lat},${opport.lng}&markers=${opport.lat},${opport.lng}`) : ""}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const {data} = this.props.location.state;

    
    console.log(this.props.location,'87')

    if (!data) {
      return <div>Cargando...</div>;
    }
    // if (StoreModel.isError(opportunity)) {
    if (!data) {
      return (
        <Grid container className={classes.root} spacing={16}>
          <Grid item xs={12}>
            <Paper elevation={11} style={{ padding: 40, textAlign: "center" }}>
              <Typography variant="display2" style={{ paddingBottom: 20 }}>
                :(
              </Typography>
              <Typography variant="title">
                El registro de visita que buscas no se ha podido cargar
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      );
    }
    return this.renderOpportunity(data);
  }
}

const mapStateToProps = (state: IStore, ownProps: DriverDetailPageProps) => ({
  ...ownProps,
  // visitDriver: state.visit.all.data[ownProps.match.params.id],
  config: state.config.data,
});

const styled = withStyles(styles as any)(DriverDetailPage);
const connected = connect(mapStateToProps, bindActions(DriverActions))(styled)
export default connected as React.ComponentClass<Partial<DriverDetailPageProps>>;


// WEBPACK FOOTER //
// ./src/pages/DriverDetailPage.tsx